/**
   * Check if the given item is a log item.
   * @param {Object} item - The item to check.
   * @returns {boolean} - Returns true if the item is a log item, false otherwise.
   */
export const isLogItem = (item) => {
    return item?.type === "logItem";
}

/**
 * Returns an object containing fields for log item tooltips.
 * @param {Function} t - Translation function
 * @returns {Object} Object with gridColumns and fields properties
 */
export const getLogItemTooltipFields = (t, locale) => {
    return {
        gridColumns: 2,
        fields: [
            {
                fieldName: t("input.category"),
                keyName: "category"
            },
            {
                fieldName: t("input.location"),
                keyName: "serviceName"
            },
            {
                fieldName: t("input.fa_owner_group"),
                keyName: "issueOwnerGroup"
            },
            {
                fieldName: t("input.lastUpdate"),
                keyName: "lastUpdate",
                type: "date",
                locale: locale,
            }
        ]
    }
}